import { Form, TableColumnType } from '@/components';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ItemMenuTreeTableNode } from './convertItemMenuItemsToTreeTableData';

const sharedOnCell = (record: ItemMenuTreeTableNode) => {
  if (record.itemDescription) {
    return { colSpan: 0 };
  }

  return {};
};

export const useMenuItemColumns = (
  isEditing: boolean,
  name: string,
  hideSubCategories: boolean,
  hideSubCategories2: boolean,
  hideItems: boolean,
  selectedRowKeys: string[],
) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'itemMenus.details' });

  return useMemo<TableColumnType<ItemMenuTreeTableNode>[]>(() => {
    const columns: Array<TableColumnType<ItemMenuTreeTableNode> | false> = [
      {
        title: t('category'),
        dataIndex: 'category',
        key: 'category',
        onCell: sharedOnCell,
        render: (_, record) =>
          record.item || record.subCategory1 || record.subCategory2
            ? undefined
            : record.category?.name,
      },
      !hideSubCategories && {
        title: t('subCategory1'),
        dataIndex: 'subCategory1',
        key: 'subCategory1',
        onCell: sharedOnCell,
        render: (_, record) =>
          record.item || record.subCategory2?.name ? (
            <></>
          ) : (
            record.subCategory1?.name
          ),
      },
      !hideSubCategories2 && {
        title: t('subCategory2'),
        dataIndex: 'subCategory2',
        key: 'subCategory2',
        onCell: sharedOnCell,
        render: (_, record) =>
          record.item ? undefined : record.subCategory2?.name,
      },
      !hideItems && {
        title: t('item'),
        dataIndex: 'item',
        key: 'item',
        onCell: (record) => ({
          colSpan: record.itemDescription ? 6 : 1,
        }),
        render: () => <></>,
      },
      {
        title: t('min'),
        dataIndex: 'min',
        key: 'min',
        onCell: sharedOnCell,
        render: (_, record) =>
          isEditing && !record.item && !record.itemDescription ? (
            <Form.Number
              name={`${name}[${record.id}].min`}
              label={false}
              className="w-100"
              min={0}
              max={99}
              disabled={!selectedRowKeys.includes(record.key)}
              placeholder={'0'}
            />
          ) : (
            <span>{record.min}</span>
          ),
      },
      {
        title: t('max'),
        dataIndex: 'max',
        key: 'max',
        onCell: sharedOnCell,
        render: (_, record) =>
          isEditing && !record.item && !record.itemDescription ? (
            <Form.Number
              name={`${name}[${record.id}].max`}
              label={false}
              className="w-100"
              min={0}
              max={99}
              disabled={!selectedRowKeys.includes(record.key)}
              placeholder={'99'}
            />
          ) : (
            <span>{record.max}</span>
          ),
      },
    ];
    return columns.filter(
      (x) => !!x,
    ) as TableColumnType<ItemMenuTreeTableNode>[];
  }, [
    hideItems,
    hideSubCategories,
    hideSubCategories2,
    isEditing,
    name,
    selectedRowKeys,
    t,
  ]);
};
